import React, { Component } from 'react';

export default class SearchInput extends Component {
	constructor(props) {
		super(props);
		this.initialPlaceholderText = 'Wonach suchst du?';
		this.state = {
			"placeholderActive": true,
			"placeholderText": this.initialPlaceholderText,
			"placeholderTexts": [
				'Tatort',
				'ARD',
				'Kinder'
			],
			"query": props.query
		};
		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.clearSearch = this.clearSearch.bind(this);
    	this.handleChange = this.handleChange.bind(this);
		this.placeholderTimer = null;
	}

	switchPlaceholder(onOff) {
		if (onOff === 'off') {
			this.setState({"placeholderText": ""});

			clearTimeout(this.placeholderTimer);
		} else {
			let textList = this.state.placeholderTexts;
			this.setState({"placeholderText": textList.shift()});
			textList.push(this.state.placeholderText);
			this.setState({"placeholderTexts": textList});
		}
	}

	placeholderTick() {
		clearTimeout(this.placeholderTimer);
		this.placeholderTimer = setTimeout(function() {
			this.switchPlaceholder();
			this.placeholderTick();
		}.bind(this), 3E3);
	}

	componentDidMount() {
		this.placeholderTick();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.query !== this.state.query) {
			this.setState({"query": nextProps.query});
			this.input.value = nextProps.query;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (nextProps.query !== this.state.query) || (nextProps.placeholderText !== this.state.placeholderText) || (nextState.query !== this.state.query);
	}

	handleFocus() {
		this.switchPlaceholder('off');
		
		let searchHolder = document.getElementById('search');
		searchHolder.className = 'searching';
	}

	handleBlur() {
		this.setState({"placeholderText": this.initialPlaceholderText});
		this.placeholderTick();

		let searchHolder = document.getElementById('search');
		searchHolder.classList.remove('searching');
	}

	clearSearch() {
		this.props.clearSearch();
		this.handleBlur();
	}

	handleChange(event) {
		// this.setState({"query": event.target.value});
		this.props.onInputChange(event);
	}

	render() {
		let clearX = (this.state.query) ? <span key="0" className="clearSearch" onClick={this.clearSearch}>&times;</span> : null;

		return [
			clearX,
			<input key="1" id="search-input" type="text" ref={(input) => this.input = input} defaultValue={this.state.query} placeholder={this.state.placeholderText} onFocus={this.handleFocus} onBlur={this.handleBlur} onChange={this.handleChange} />
		];
	}
}


// WEBPACK FOOTER //
// ./src/SearchInput.js